import store from '@/store'
export default {
    computed: {
       products() {return store.getters['app-ecommerce/getCurrentProducts']}
    }
}